import React from 'react';
import { TakeOffOrdersProps } from './types';
import { ArcSkeleton, ArcStack } from '@src/core/ui';
import { ArcOrderCard } from '@src/core/components';

const TakeOffOrders: React.FC<TakeOffOrdersProps> = (props) => {
  const { orders, isLoading } = props;

  if (isLoading) {
    return (
      <ArcStack>
        <ArcSkeleton width='calc(50% - 4px)' height={70} />
        <ArcSkeleton width='calc(50% - 4px)' height={70} />
        <ArcSkeleton width='calc(50% - 4px)' height={70} />
        <ArcSkeleton width='calc(50% - 4px)' height={70} />
      </ArcStack>
    );
  }

  return (
    <ArcStack spacing={1}>
      <ArcStack gap={1} direction='row' flexWrap='wrap'>
        {orders.map((order) => {
          return (
            <ArcOrderCard 
              key={order?.id} 
              sx={{ marginTop: '16px'}} 
              order={order} 
              isSelected={false} 
              fullWidth={true} 
              onClick={() => {}} index={0} />
          );
        })}
      </ArcStack>
    </ArcStack>

  );
};

export default TakeOffOrders;